const getters = {
  getDate: (state) => state.date,
  getNota: (state) => state.nota,
  getToken: (state) => state.token,
  getProdutos: (state) => state.produtos,
  getBeneficio: (state) => state.beneficio,
};

export default getters;
